import "../css/Projects.css"
import ncNewsFE from "../media/ncnewstablet.png"
import BE from "../media/backend.jpg"
import WorldCapitals from "../media/WorldCapitals.png"

export const Projects = () => {
    return <div className="portfolio-page-container">
        <div>
            <h3>PROJECTS</h3>
            <p>Two projects produced during Northcoders Bootcamp</p>
        </div>
        <div className="projects-container">
            <div className="single-project-container">
                <img src={BE} alt="NC News Back End"></img>
                <p>NC News - <b>Back End Project</b> - Node.js back-end and PSQL Database</p>
                <div className="links-container">
                    <div className="link">
                        <a href="https://solveiga-nc-news-be.herokuapp.com/api" target="_blank" rel="noreferrer">Visit</a>
                    </div>
                    <div className="link">
                        <a href="https://github.com/solveigag/BE-NC-News-project" target="_blank" rel="noreferrer">GitHub</a>
                    </div>
                </div>
            </div>
            <div className="single-project-container">
                <img src={ncNewsFE} alt="NC News Front End"></img>
                <p>NC News - <b>React Front End Project</b> - Reddit Style social site</p>
                <div className="links-container">
                    <div className="link">
                        <a href="https://sols-nc-news.netlify.app" target="_blank" rel="noreferrer">Visit</a>
                    </div>
                    <div className="link">
                        <a href="https://github.com/solveigag/nc-news" target="_blank" rel="noreferrer">GitHub</a>
                    </div>
                </div>
            </div>
            <div className="single-project-container">
                <img src={WorldCapitals} alt="World Capitals Quiz"></img>
                <p>World Capitals Quiz - <b>React Front End Project</b> - A quiz with countdown</p>
                <div className="links-container">
                    <div className="link">
                        <a href="https://world-capitals-quiz.netlify.app" target="_blank" rel="noreferrer">Visit</a>
                    </div>
                    <div className="link">
                        <a href="https://github.com/solveigag/capitals-quiz.git" target="_blank" rel="noreferrer">GitHub</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
}